import * as React from "react";
import { Helmet } from "react-helmet";
import { withToastManager } from "react-toast-notifications";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";

// Components/Presentation UI
import PageWrapper from "../../Components/Layouts/PageWrapper";
import SignUpWrapper from "../../Components/Layouts/SignUpWrapper";

import CustomerRequestCodeForm from "./CustomerRequestCodeForm";
import RequestForm from "./RequestForm";

// Utils
import { decryptEncryptedStringValue } from "../../Utils/Helpers";
import { CUSTOMER_VERIFIED } from "../../Utils/LocalStorage";

interface IPathParams {
  customerId: string;
}

type PropsType = RouteComponentProps<IPathParams> & {
  computedMatch: {
    params: {
      customerId: string;
    };
  };
  toastManager: any;
};

class CustomerRequestPortal extends React.Component<PropsType> {
  state = {
    modal: true,
    currentView: "enterCode" // or verified
  };

  componentDidMount() {
    const customerVerification = window.localStorage.getItem(CUSTOMER_VERIFIED);
    if (customerVerification) {
      this.setState({ currentView: "verified" });
    }
  }

  // Update view
  updateView = (): void => {
    this.setState({ currentView: "verified" });
  };

  // Render view
  renderView = (currentView: string): React.ReactNode => {
    const { computedMatch } = this.props;
    const customerId = decryptEncryptedStringValue(
      computedMatch.params.customerId
    );

    if (currentView === "enterCode") {
      return (
        <CustomerRequestCodeForm
          customerId={customerId}
          notification={this.toastNotification}
          updateView={this.updateView}
        />
      );
    }

    return (
      <SignUpWrapper>
        <RequestForm
          customerId={customerId}
          notification={this.toastNotification}
        />
      </SignUpWrapper>
    );
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    const { currentView } = this.state;
    return (
      <PageWrapper>
        {this.renderView(currentView)}
        <Helmet title="Customer Request Portal" />
      </PageWrapper>
    );
  }
}

export default withRouter(withToastManager(CustomerRequestPortal));



// WEBPACK FOOTER //
// ./src/Containers/CustomerRequestPortal/index.tsx